module.exports = __webpack_public_path__ + "img/61exp.a625323a.jpg";